// eslint-disable-next-line import/no-unresolved
import auth from '@/middleware/auth'

const formTable = [
  // CREATIONS
  {
    path: '/tarifas-x-km-cars/list',
    name: 'tarifas-x-km-cars-list',
    // eslint-disable-next-line import/no-unresolved
    component: () => import('@/views/nomencladores/cars/TarifasXKm.vue'),
    meta: {
      layout: 'content',
      middleware: auth,
      pertenece: 'nom_tarifas_x_km_cars',
    },
  },
]

export default formTable
